import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { useGetPayoutExtractGridQuery,useGetPayoutExtractExportQuery } from '../../../pages/compensation/compensationSlice';
import { exportExcel } from './reExportHistoryService';
import { DateTemplate } from '../../../components/dateTemplate/DateTemplate';
import { ExportButtonTemplate } from './ExportButtonTemplate';
import { formatDate2 } from '../../../utils/dateFormat';
import { monthNames } from '../../../utils/typeConstants';

export interface ExportHistoryPropTypes {
    yearInput?: number;
    monthInput?: number;
}

const ExportHistory = ({
    yearInput,
    monthInput
}:ExportHistoryPropTypes) => {
    const [date, setDate] = useState(new Date(`${monthInput}-01-${yearInput}`));
    const [inputMonth, setMonth] = useState(monthInput);
    const [inputYear, setYear] = useState(yearInput);
    const [payoutExtractGridList, setPayoutExtractGridList] = useState([]);
    const [payoutExtractId, setpayoutExtractId] = useState<number>(0);

    const { data: payoutExtractGridData } = useGetPayoutExtractGridQuery({
        year: inputYear,
        month: inputMonth,
    }, { skip: !inputMonth || !inputYear });

    const { data: payoutExtractExportData } = useGetPayoutExtractExportQuery({
        payoutExtractId
    }, { skip: (!payoutExtractId || payoutExtractId === 0) });

    const exportingData = (exportData: any) => {
        const exportHistoryDetails = [{}];
        for (let i = 0; i < exportData.length; i++) {
            const managerData =
                    exportData[i].manager_name !== null ? exportData[i].manager_name.split('(') : '';
                const managerName = managerData?.length > 0 ? managerData[0] : '';
                const managerId = managerData?.length > 1 ? managerData[1]?.split(')')[0] : '';
                const compData =
                    exportData[i].comp_export !== null ? exportData[i].comp_export.split('(') : '';
                const compName = compData?.length > 0 ? compData[0] : '';
                const compId = compData?.length > 1 ? compData[1]?.split(')')[0] : '';
                const exportDate =
                    exportData[i].extract_date !== null ? formatDate2(exportData[i].extract_date) : '';
                const managerDate =
                    exportData[i].manager_approval_date !== null
                        ? formatDate2(exportData[i].manager_approval_date)
                        : '';
                const tlApprovalStatus=exportData[i].tl_status !== null ? exportData[i].tl_status : '';
                const mngrApprovalStatus=exportData[i].manager_status !== null ? exportData[i].manager_status : '';
                const agentApprovalStatus=exportData[i].agent_status !== null ? exportData[i].agent_status : '';
                const performancePeriod = `${monthNames[Number(exportData[i].month)]} ${exportData[i].year}`;
                        exportHistoryDetails.push({
                    'Country':`${exportData[i].country_name}`,
                    'Geographic Location':`${exportData[i].geo_location_name}`,
                    'Parent Client':`${exportData[i].parent_client_name}`,
                    'Performance Period':performancePeriod,
                    'Scorecard ID': `${exportData[i].scorecard_id}`,
                    'Scorecard Name': `${exportData[i].scorecard_name}`,
                    'Payroll Element': ` `,
                    'Team Lead Approval Status': tlApprovalStatus,
                    'Associate Approval Status': agentApprovalStatus,
                    'Employee ID': `${exportData[i].employee_number}`,
                    'Employee Name': `${exportData[i].employee_name}`,
                    'Employee Role': `${exportData[i].employee_role}`,
                    'Empower Totals': `${exportData[i].payout}`,
                    'Manager Approval Status': mngrApprovalStatus,
                    'Manager Name': managerName,
                    'Manager ID': managerId,
                    'Manager Date': managerDate,
                    'Export Date': exportDate,
                    'Export Comp ID': compId,
                    'Export Comp Name': compName,                    
                });
        }
        return exportHistoryDetails;
    };
    useEffect(() => {
        if (window.localStorage.ExportHistoryfilDate) {
            const storedDate = new Date(window.localStorage.ExportHistoryfilDate);
            if (storedDate) {
                setDate(storedDate);
                setMonth(storedDate.getMonth() + 1);
                setYear(storedDate.getFullYear());
            }
        }
    },[])

    useEffect(() => {
        if (payoutExtractGridData?.data.length > 0) {
            setPayoutExtractGridList(payoutExtractGridData?.data);
        }
    }, [payoutExtractGridData]);

    useEffect(() => {
        if (payoutExtractExportData?.data.length > 0) {
            exportExcel(exportingData(payoutExtractExportData?.data));
        }
    }, [payoutExtractExportData]);

    const DateOnChange = (e: any) => {
        setDate(e.value);
        setMonth(e.value.getMonth() + 1);
        setYear(e.value.getFullYear());
        window.localStorage.ExportHistoryfilDate = e.value;
    };
    
    const handleExport = (payoutExtractId: any) => {       
        setpayoutExtractId(payoutExtractId);
    };

    return (
        <div className="card mt-3 ms-0 me-0 bg-body rounded border-0">
            <div className="card-body p-0 align-middle text-center table">
                <div className='row'>
                    <div className='col-md-3'>
                        <div style={{display:"flex",flexDirection:"column",marginLeft:"20px"}}>
                            <label htmlFor='perfomanacePeriod' style={{textAlign:"left",margin:"0px 0px 0px 2px"}}>Performance Period</label>
                            <Calendar
                                id='perfomanacePeriod'
                                value={date}
                                onChange={DateOnChange}
                                view="month"
                                maxDate={new Date()}
                                showIcon
                                className="custom-calendar me-4 mt-3"
                                dateFormat="MM, yy"
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <DataTable
                        value={payoutExtractGridList}
                        id="exportHistoryTable"
                        rows={5}
                        paginator={payoutExtractGridList?.length > 5}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        emptyMessage="No records found."
                    >
                        <Column
                            header="Payout Name"
                            field='payout_extract_name'
                            sortable
                        />
                        <Column
                            header="Extract Date"
                            field='extract_date'
                            body={(rowData: any) => DateTemplate(rowData.extract_date)}
                            sortable
                        />
                        <Column
                            header="Extract by"
                            field='extract_by'
                            sortable
                        />
                        <Column
                            style={{ width: "10rem" }}
                            body={(rowsData: any) => ExportButtonTemplate(rowsData.payout_extract_id,handleExport)}
                            
                        />
                    </DataTable>
                </div>
            </div>
        </div>
    );
};

export default ExportHistory;
